<template>
    <div class="TopicsTopEntrance" v-loading="loading">
        <div class="TopicsTopEntrance-header">
            <div>跑区管理</div>
            <div>
                <el-button type="primary" @click="handleAdd">新增跑区</el-button>
                <el-button type="primary" @click="$router.go(-1)">返回</el-button>
            </div>
        </div>
        <el-table :data="tableData" border>
            <el-table-column type="index" label="序号" align="center" width="120" />
            <el-table-column prop="name" label="跑区名称" align="center" />
            <el-table-column label="涉及围栏" align="center" inline-template>
                <div>{{ row.fenceName && row.fenceName.length && row.fenceName.join(',') }}</div>
            </el-table-column>
            <el-table-column label="更新时间" align="center" inline-template>
                <div>{{ new Date(row.updateAt).format('yyyy-MM-dd') }}</div>
            </el-table-column>
            <el-table-column inline-template label="操作" width="200px" align="center">
                <template>
                    <el-button type="primary" size="small" @click="handleDetail(row)">
                        跑区信息
                    </el-button>
                    <el-button type="primary" size="small" @click="handleDelete(row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [],
            loading: false
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        handleDetail(row) {
            this.$router.push({
                path: '/xiaoyuan/GX/runareaDetail',
                query: {
                    unid: this.$route.query.unid,
                    id: row.id
                }
            })
        },
        handleDelete(row) {
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/v1/campus/runArea/delete',
                params: {
                    id: row.id
                }
            }).then(res => {
                if (res.body.error === 10000) {
                    this.getTableData()
                } else {
                    this.$util.errorMsg(res.body.message);
                }
            })
        },
        handleAdd() {
            this.$prompt('请输入跑区名称', '新增', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                if (!value) {
                    return
                }
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v1/campus/runArea/saveOrEdit',
                    body: JSON.stringify({
                        unid: this.$route.query.unid,
                        name: value,
                        fenceIds: []
                    })
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.$util.successMsg('操作成功');
                        this.getTableData()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                }).catch(() => {
                    this.$util.errorMsg('服务器内部错误');
                })
            })
        },
        getTableData() {
            if (!this.$route.query.unid) {
                return false
            }
            this.loading = true
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/v1/campus/runArea/list',
                params: {
                    unid: this.$route.query.unid
                }
            }).then(res => {
                if (res.body.error === 10000 && res.body.data && res.body.data.length) {
                    this.tableData = res.body.data
                } else {
                    this.tableData = []
                    this.$util.errorMsg(res.body.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>


<style scoped>
.TopicsTopEntrance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eee;
    font-size: 16px;
    padding: 0 10px 0 30px;
    margin: 20px 0;
}

.TopicsTopEntrance-main {
    padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?4dad9438